var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c(_vm.template, {
    tag: "component"
  }, [_c('v-container', [_c('div', {
    staticClass: "contents-area"
  }, [_c('div', {
    staticClass: "contents-area__inner"
  }, [_c('div', {
    staticClass: "tit-wrap mb-0"
  }, [_c('h2', {
    staticClass: "tit"
  }, [_vm._v("상품권 구매하기")]), _c('div', {
    staticClass: "font-size-14 font-size-md-16 grey--text text--garken-3"
  }, [_vm._v(" PG 결제를 통해 나누리 캐시 교환권을 구매하실 수 있습니다. ")])]), _c('v-divider', {
    staticClass: "my-6 my-lg-12"
  }), !_vm.order._id ? void 0 : _vm.method === 'vaccount' ? [_c('v-card', {
    staticClass: "my-6 my-lg-12 mx-auto",
    attrs: {
      "max-width": "480",
      "color": "transparent",
      "elevation": "0"
    }
  }, [_c('v-card-title', {
    staticClass: "justify-center"
  }, [_vm._v(" 주문이 완료되었습니다. ")]), _c('v-card-text', {
    staticClass: "pb-0 text-center"
  }, [_c('p', [_vm._v("아래 가상계좌에 출금계좌를 통해 해당 금액을 입금해주세요.")])])], 1), _c('nshop-order-view-table', _vm._b({
    staticClass: "my-6 my-lg-12 mx-auto",
    staticStyle: {
      "max-width": "480px"
    }
  }, 'nshop-order-view-table', {
    value: _vm.order
  }, false))] : _vm.method === 'openbank' ? [_c('v-card', {
    staticClass: "my-6 my-lg-12 mx-auto",
    attrs: {
      "max-width": "480",
      "color": "transparent",
      "elevation": "0"
    }
  }, [_c('v-card-title', {
    staticClass: "justify-center"
  }, [_vm._v(" 결제가 완료되었습니다. ")]), _c('v-card-text', {
    staticClass: "pb-0 text-center"
  }, [_vm.issued ? [_vm._v(" 상품권이 발급되어"), _c('br'), _vm._v(" 본인의 전화번호로 전송되었습니다."), _c('br'), _vm._v(" 휴대폰 문자를 확인해주세요. ")] : [_vm._v(" 발급을 확인하고 있습니다. 잠시만 기다려주세요…"), _c('br'), _c('v-progress-circular', {
    staticClass: "mt-2",
    attrs: {
      "indeterminate": "",
      "size": "20",
      "width": "2"
    }
  })]], 2)], 1), _c('nshop-order-view-table', _vm._b({
    staticClass: "my-6 my-lg-12 mx-auto",
    staticStyle: {
      "max-width": "480px"
    }
  }, 'nshop-order-view-table', {
    value: _vm.order
  }, false)), _vm.issued ? _c('div', {
    staticClass: "mx-auto mb-6 mb-lg-12",
    staticStyle: {
      "max-width": "480px"
    }
  }, [_c('v-btn', {
    attrs: {
      "x-large": "",
      "block": "",
      "color": "primary"
    },
    on: {
      "click": _vm.gain
    }
  }, [_vm._v(" 충전하기 ")])], 1) : _vm._e()] : true ? [_c('v-card', {
    staticClass: "my-6 my-lg-12",
    attrs: {
      "color": "transparent",
      "elevation": "0"
    }
  }, [_c('v-card-title', {
    staticClass: "justify-center"
  }, [_vm._v(" 결제가 완료되었습니다. ")]), _c('v-card-text', {
    staticClass: "text-center"
  }, [_vm._v(" 확인된 상품권은 1~5분 내로"), _c('br'), _vm._v(" 본인의 전화번호로 전송됩니다."), _c('br'), _vm._v(" 휴대폰 문자를 확인해주세요. ")])], 1)] : _vm._e(), _c('div', {
    staticClass: "mx-auto",
    staticStyle: {
      "max-width": "480px"
    }
  }, [_c('v-row', {
    staticClass: "ma-n1"
  }, [_c('v-col', {
    staticClass: "pa-1"
  }, [_c('v-btn', {
    attrs: {
      "x-large": "",
      "block": ""
    },
    on: {
      "click": _vm.exit
    }
  }, [_vm._v(" 홈으로 ")])], 1), _c('v-col', {
    staticClass: "pa-1"
  }, [_c('v-btn', {
    attrs: {
      "x-large": "",
      "block": "",
      "color": "primary"
    },
    on: {
      "click": _vm.more
    }
  }, [_vm._v(" 추가 구매하기 ")])], 1)], 1)], 1)], 2)])]), _c('common-loader', _vm._b({}, 'common-loader', {
    loading: _vm.loading
  }, false))], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }